import {
  QrCode,
  PhoneIphone,
  LocalDining,
  CheckCircle,
  MenuBook,
  TableBar,
  Dashboard,
  Payment,
  Groups,
  BarChart,
  TouchApp,
  NotificationsActive,
  Devices,
  Bolt,
  Language,
  ShoppingCart,
  Star,
} from '../icons';

// Maps the string icon keys used in landingContent to their components, so the
// content module stays plain data and sections render icons by name.
const ICON_MAP = {
  QrCode,
  PhoneIphone,
  LocalDining,
  CheckCircle,
  MenuBook,
  TableBar,
  Dashboard,
  Payment,
  Groups,
  BarChart,
  TouchApp,
  NotificationsActive,
  Devices,
  Bolt,
  Language,
  ShoppingCart,
  Star,
};

export function getLandingIcon(name) {
  return ICON_MAP[name] || Star;
}
